import { render, staticRenderFns } from "./RoundPointerIcon.vue?vue&type=template&id=568a869e&"
import script from "./RoundPointerIcon.vue?vue&type=script&lang=js&"
export * from "./RoundPointerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports